import { useEffect } from 'react';

type Dimensions = {
    innerWidth: number;
    innerHeight: number;
};

type Handler = (dimensions: Dimensions) => void;

/** Эффект, срабатывает при изменении размеров окна */
export const useWindowResize = (onResize: Handler, deps: any[] = [], checkVisualViewport = false) => {
    const handler = () => {
        const {
            innerHeight,
            innerWidth,
            visualViewport,
        } = window;
        const { width, height } = visualViewport || {} as never
        onResize(checkVisualViewport ? { innerHeight: height, innerWidth: width } : { innerHeight, innerWidth });
    };

    return useEffect(() => {
        if (checkVisualViewport) {
            window.visualViewport?.addEventListener('resize', handler);
        } else {
            window.addEventListener('resize', handler);
        }

        return () => {
            if (checkVisualViewport) {
                window.visualViewport?.removeEventListener('resize', handler);
            } else {
                window.removeEventListener('resize', handler);
            }
        };
    }, deps);
};
